import React from 'react';
import { CategoryThumbnail } from '@components/attachments';

export const CategoryCard = ({ category, displayType, onClick, actions }) => {
    return (
        <div className={`category-card ${displayType}`} onClick={onClick}>
            {displayType === 'list' ? (
                <>
                    <div className="category-thumbnail-container">
                        <CategoryThumbnail
                            categoryId={category.id}
                            categoryName={category.name}
                            size="medium"
                            thumbnailSize={80}
                        />
                    </div>
                    <div className="content">
                        <h3>{category.name}</h3>
                        <p>{category.description}</p>
                    </div>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            ) : (
                <>
                    <div className="category-thumbnail-container grid-thumbnail">
                        <CategoryThumbnail
                            categoryId={category.id}
                            categoryName={category.name}
                            size="large"
                            thumbnailSize={80}
                        />
                    </div>
                    <h3>{category.name}</h3>
                    <p>{category.description}</p>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            )}
        </div>
    );
};

export default CategoryCard;
